/**
 * The "All | Assigned | Unassigned" pill beside the account list's heading. It
 * changes the whole page (the headline numbers and the list). Only Clerk org
 * admins get more than one choice; members don't see the pill at all.
 */

import { useTranslation } from "react-i18next";
import type { BookScope } from "@onsemble/shared/types/sales-insights";
import { SegmentedControl } from "./SegmentedControl";

export function AccountScope({
  scope,
  scopes,
  onChange,
}: {
  /** The picked choice */
  scope: BookScope;
  /** The choices this user has, in picker order */
  scopes: BookScope[];
  /** Called with the choice the user clicks */
  onChange: (next: BookScope) => void;
}) {
  const { t } = useTranslation();
  // On-screen word, plus a fuller name for screen readers
  const options = scopes.map((value) => ({
    value,
    label: t(`pages.pcInsights.controls.${value}`),
    name: t(`pages.pcInsights.controls.${value}Name`),
  }));

  return (
    <SegmentedControl
      label={t("pages.pcInsights.controls.scopeLabel")}
      options={options}
      value={scope}
      onChange={onChange}
    />
  );
}
